import { render, staticRenderFns } from "./_name.vue?vue&type=template&id=417df7e4&scoped=true"
import script from "./_name.vue?vue&type=script&lang=js"
export * from "./_name.vue?vue&type=script&lang=js"
import style0 from "./_name.vue?vue&type=style&index=0&id=417df7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417df7e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
